import React, { Component, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { convertObjectToArray, getRemotedbUrl, i18nIntl, importCSS } from '../../../lib/ep.js';
import { useCSS } from '../../../lib/hooks.js';
import { answerScore } from '../../../lib/qz.js';

import Spinner from '../../builder/Spinner';
import LeveledHTMLText from '../helpers/LeveledHTMLText.js';
import { InformationMessage } from '../../builder/Message.js';

const SingleAnswer = (props) => {
	const type = (props.type != undefined) ? props.type.replace("-", "_") : "closed_text";
	const is_builder = props?.is_builder ?? false;
	const is_correct = props?.is_correct ?? false;
	const has_correct_answer = props?.has_correct_answer ?? false;
	const has_correct_ordered_answer = props?.has_correct_ordered_answer ?? false;
	const is_multiorder = props?.is_multiorder ?? false;

	let classes = ['selected_answer', `is_${type}`, 'gui_small_icon'];

	// always visible if correct / incorrect (if quiz answers are public):
	let label_answer = props.children;
	if(is_multiorder){
		const index_number = props.order;
		label_answer = `${index_number}.  ${props.children}`;
	}
	
	if(is_multiorder  && !has_correct_ordered_answer/* && false*/){
		//Pregunta multiordre i no resolta (cap resposta amb punts)
		//Per si es vol posar l'ordre numeric a les respostes, treure false
		//classes.push(index_number <= 9 ? `knk-counter-number-${(index_number)}` : (is_correct ? 'knk-on' : 'knk-help'));
	}else if(/*is_builder || */has_correct_answer) {
		classes.push((is_correct) ? 'ep-check-list-item greenIcon' : 'ep-delete-circle redIcon');
	}

	return (
		<strong class={classes.join(" ")}>{label_answer}</strong>
	)
};

const QuizStatsPublic = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	useCSS('comp/quiz.css');

	const [ loading, setLoading ] = useState(true);
	const [ quiz_stats, setQuizStats ] = useState([]);
	const [ delay, setDelay ] = useState(false);
	const [ running, setRunning ] = useState(true);

	const hide_not_selected_answers = false;
	const is_builder = props?.is_builder ?? false;
	const promotion_id = props?.promotion_id ?? false;
	const user_id = props?.user_id ?? false;
	const stage_id = props?.stage_id ?? false;


	useEffect(() => {
		setLoading(true);
		var quiz_stats_url = `/quizs/stats/${promotion_id}/${user_id}`;
		if(stage_id !== false) quiz_stats_url += `/${stage_id}`;

		$.post(getRemotedbUrl(quiz_stats_url), (response) => {
			setLoading(false);
			setQuizStats(response.questions);
			setDelay(response?.delay ?? false);
			setRunning(response?.running ?? true);
		}, 'JSON');
	}, []);

	const cleanString = (input) => {
		return input
			.replace(/<\/?(p|div|h[1-6]|ul|ol|li|blockquote|pre)\b[^>]*>/gi, '\n') // Reemplaza etiquetas block por saltos de línea
			.replace(/<\/?[a-z][a-z0-9]*\b[^>]*>/gi, '') // Elimina todas las demás etiquetas HTML
			.replace(/\n+/g, '\n') // Evita múltiples saltos de línea seguidos
			.replace(/\n/g, '<br>'); // Reemplaza saltos de línea por <br>
	}

	const detectIfQuestionHasCorrectAnswerDefined = (question_answers) => {
		let has_correct_answer_defined = question_answers.filter((answer) => (answer.correct != undefined && answer.correct != '0'));
		return (has_correct_answer_defined.length > 0) ? true : false;
	};

	const detectIfQuestionHasCorrectOrderedAnswerDefined = (question,answers) => {
		if(question.multiorder == 0)return false;
		let has_correct_answer_defined = detectIfQuestionHasCorrectAnswerDefined(answers);
		let has_ordered_answer_defined = answers.filter((answer) => ((answer?.config?.correct_values ?? '') != ''));

		return (has_correct_answer_defined && has_ordered_answer_defined.length > 0) ? true : false;
	};

	if(loading) {
		return (
			<LeveledHTMLText
				_class={{ other:'gui_participations_list gui_pos_rel' }}
				style={{ minHeight:'2em' }}
			>
				<Spinner
					color='--main-color'
				/>
			</LeveledHTMLText>
		)
	}
	
	if(quiz_stats.length == 0) {
		return null;
	}

	const display_message_delay = delay && !is_builder && running ? false : false;//No el mostrem mai
	
	return (
		<LeveledHTMLText
			_class={{ other:'gui_participations_list' }}
			style={{ minHeight:'80px' }}
		>
			<section class="gui_quiz_public_stats" style={{marginBottom:'2em'}}>
				{quiz_stats.map((q_stats, q) => {
					const question = q_stats.Question;

					let has_answered = false;
					q_stats.Answer.map((ans, an) => {
						if(parseFloat(ans.totalpercent) > 0) has_answered = true;

						if(!has_answered && ans.total != undefined) {
							(convertObjectToArray(ans.total)).map((f) => {
								if(f.percent != undefined && parseFloat(f.percent) > 0) has_answered = true;
							});
						}
					});

					if(!has_answered) return null;

					return (
						<article key={q} class="question_block">
							<p class="question_text" dangerouslySetInnerHTML={{ __html:cleanString(question.question) }} />

							<div class="answer_block">
								{q_stats.Answer.map((a_stats, a) => {
									const answer_type = a_stats.config.type;
									const answer_totals = (a_stats.total != undefined) ? convertObjectToArray(a_stats.total) : [];

									var display_suboptions = false;
									var selected_rating = 0;

									switch(answer_type) {
										case 'closed_text':
										case 'image':
										case 'open_text':
											if(question.multiorder) display_suboptions = true;
											break;
										case 'rating':
											display_suboptions = true;
											for(var i = 0; i < answer_totals.length; i++) {
												if(answer_totals[i].percent > 1) {
													selected_rating = i + 1;
													break;
												}
											}
											break;
										case 'list':
											display_suboptions = true;
											break;
									}

									if(hide_not_selected_answers && a_stats.totalpercent < 1) return null;

									let is_correct_answer = (a_stats.correct != '0') ? true : false;
									if(q_stats.User != undefined) {
										is_correct_answer = (answerScore(a_stats, q_stats.User.quiz_entry, q_stats.Question) > 0) ? true : false;
									}

									const is_selected = (a_stats.totalpercent > 1) ? true : false;
									if(!(is_selected || display_suboptions || answer_type == 'open_text')) return null;

									const has_correct_answer = detectIfQuestionHasCorrectAnswerDefined(q_stats.Answer);
									if(answer_type == 'rating') {
										return (
											<SingleAnswer
												key={`answer_${q}_${a}`}
												type={answer_type}
												is_builder={is_builder}
												is_correct={is_correct_answer}
												has_correct_answer={has_correct_answer}
											>
												<p>{a_stats.answer_st}</p>

												<span class="rating_answered">
													{answer_totals.map((total, t) => {
														const star_class = (selected_rating - t > 0) ? 'ep-star' : 'ep-star-empty';
														return (
															<span key={t} class={`gui_small_icon ${star_class}`} />
														)
													})}

													<span class="visual_counter">{`${selected_rating}/${answer_totals.length}`}</span>
												</span>
											</SingleAnswer>
										)
									}

									if(answer_type == 'open_text') {
										return (
											<SingleAnswer
												key={`answer_${q}_${a}`}
												type={answer_type}
												is_builder={is_builder}
												is_correct={is_correct_answer}
												has_correct_answer={has_correct_answer}
											>{a_stats.cloud_text_whole_text}</SingleAnswer>
										)
									}

									if(answer_type == 'closed_text') {
										if(a_stats.total == undefined || a_stats.total < 1) return null;
										const has_correct_ordered_answer = detectIfQuestionHasCorrectOrderedAnswerDefined(q_stats.Question,q_stats.Answer);
										return (
											<SingleAnswer
												key={`answer_${q}_${a}`}
												type={answer_type}
												is_builder={is_builder}
												is_correct={is_correct_answer}
												has_correct_answer={has_correct_answer}
												has_correct_ordered_answer={has_correct_ordered_answer}
												is_multiorder={question?.multiorder ?? 0}
												order={question?.multiorder ? (a + 1) : null}
											>{a_stats.answer_st}</SingleAnswer>
										)
									}

									if(!display_suboptions) return null;
									return (
										<span key={`answer_${q}_${a}`}>
											{answer_totals.map((total, t) => {
												if(total.percent < 1) return null;

												return (
													<SingleAnswer
														key={`answer_${q}_${a}_${t}`}
														type={answer_type}
														is_builder={is_builder}
														is_correct={is_correct_answer}
														has_correct_answer={has_correct_answer}
													>{total.key}</SingleAnswer>
												)
											})}
										</span>
									)
								})}
							</div>
						</article>
					)
				})}
			</section>
				
			{(display_message_delay) && (
				<InformationMessage
					_class={{ other:'gui_not_in_top_big in_bottom' }}
				>
					<p>{i18n("These results may not be final as this survey is currently receiving many votes. Please check back in a few minutes.")}</p>
				</InformationMessage>
			)}
		</LeveledHTMLText>
	)
}

export default injectIntl(QuizStatsPublic);